import PeopleForm from './PeopleForm';

export default PeopleForm;
